import { motion } from 'framer-motion';

interface AnimatedLogoProps {
  size?: number;
  animate?: boolean;
}

export function AnimatedLogo({ size = 60, animate = true }: AnimatedLogoProps) {
  return (
    <motion.div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      {/* Outer glow effect */}
      <motion.div
        className="absolute inset-0 rounded-full"
        style={{
          background: `radial-gradient(circle, rgba(255, 215, 0, 0.3) 0%, transparent 70%)`,
          filter: 'blur(8px)',
        }}
        animate={animate ? {
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.6, 0.3],
        } : {}}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      
      {/* Main logo - using text until proper logo is available */}
      <motion.div
        className="relative z-10 w-full h-full flex items-center justify-center text-yellow-400 font-bold"
        style={{ fontSize: size * 0.3 }}
        animate={animate ? {
          scale: [1, 1.05, 1],
        } : {}}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        CX
      </motion.div>
      
      {/* Spiral rays */}
      <motion.div
        className="absolute inset-0"
        animate={animate ? {
          rotate: [0, -360],
        } : {}}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        {[...Array(12)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-0.5 bg-gradient-to-t from-transparent via-yellow-400/50 to-transparent"
            style={{
              height: size * 0.6,
              left: '50%',
              top: '50%',
              transformOrigin: '0 50%',
              transform: `translate(-50%, -50%) rotate(${i * 30}deg) translateY(-${size * 0.3}px)`,
            }}
            initial={{ opacity: 0, scaleY: 0 }}
            animate={{ opacity: [0, 1, 0], scaleY: [0, 1, 0] }}
            transition={{
              duration: 2,
              repeat: Infinity,
              delay: i * 0.1,
              ease: "easeInOut"
            }}
          />
        ))}
      </motion.div>
    </motion.div>
  );
}